import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=a9ff160c&scoped=true&"
import script from "./watch.vue?vue&type=script&lang=js&"
export * from "./watch.vue?vue&type=script&lang=js&"
import style0 from "./watch.vue?vue&type=style&index=0&id=a9ff160c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ff160c",
  null
  
)

export default component.exports